import {useRoutes} from 'react-router-dom';
import Main from '../pages/main';
import About from '../pages/about';
import Advice from '../pages/advice';
import Conditions from '../pages/conditions';
import PrivacyPolicy from '../pages/privacyPolicy';
import CookiePolicy from '../pages/cookiePolicy';
import Contact from '../pages/contact';

export const Routers = () => {
  return useRoutes([
    {path: '/', element: <Main/>},
    {path: '/about', element: <About/>},
    {path: '/advice', element: <Advice/>},
    {path: '/conditions', element: <Conditions/>},
    {path: '/privacyPolicy', element: <PrivacyPolicy/>},
    {path: '/cookiePolicy', element: <CookiePolicy/>},
    {path: '/contact', element: <Contact/>},
  ])
}
